<script setup>
import Modal from '@/Components/Modal.vue';
import GenericButton from '@/Components/GenericButton.vue';

const emits = defineEmits(['confirmed', 'close', 'update:toggleModal']);

const props = defineProps({
  show: Boolean,
  title: {
    type: String,
    default: 'Confirmation',
  },
  message: {
    type: String,
    default: '',
  },
  deletedId: {
    type: Number,
    default: null,
  },
});
</script>

<template>
  <Modal :show="show" @close="$emit('update:toggleModal')">
    <div class="p-6 dark:bg-theme-paper">
      <h2 class="text-lg font-medium text-theme-primary dark:text-theme-primary">
        {{ title }}
      </h2>

      <p class="mt-1 text-sm text-grey-600 dark:text-theme-secondary">
        {{ message }}
      </p>

      <div class="flex justify-end flex-1 gap-2 mt-6">
        <GenericButton
          theme="outline"
          
          @click="$emit('update:toggleModal')"
              >
          {{ $t('Cancel') }}
        </GenericButton>

        <GenericButton
          theme="secondary"
          
          @click="$emit('confirmed', deletedId)"
              >
          {{ $t('Yes') }}
        </GenericButton>
      </div>
    </div>
  </Modal>
</template>

<style scoped></style>
